import {host} from '@utils/hostConf';
import * as http from '@utils/baseRequest';

// 科室查询 | 查询分院的科室
export function fetchDoctorList(data) {
  let postData = {
    page_no: '1',
    page_size: '10',
    ...data,
  };
  return http.post({
    url: host.cplus + 'cgi-bin/search/doctorrecommendv2',
    data: postData,
  });
}

export function fetchByDoctorList(data) {
  return http.get({
    url: host.cplus + 'cgi-bin/user/querydoctorsthlist',
    data,
  });
}

// 查询医生title
export function fetchDocTitl(data) {
  return http.post({
    url: host.cplus + 'cgi-bin/search/getfiltertitles',
    data: data,
  });
}

// 查询价格
export function fetchDocPrices(data) {
  return http.get({
    url: host.cplus + 'cgi-bin/search/getfilterprices',
    data,
  });
}

// 查询医生信息
export function fetchDocInfo(data) {
  return http.get({
    url: host.cplus + 'cgi-bin/user/querydoctor',
    data,
  });
}

// 查询评论标签
export function fetchCommentTag(data) {
  return http.get({
    url: host.cplus + 'cgi-bin/comment/querytag',
    data,
  });
}

// 添加评论
export function saveComment(data) {
  return http.post({
    url: host.cplus + 'cgi-bin/comment/addcomment',
    data,
  });
}

// 编辑评论
export function editComment(data) {
  return http.post({
    url: host.cplus + 'cgi-bin/comment/modifycomment',
    data,
  });
}

// 新冠治疗医生列表
export function querySearchDoc(data) {
	return http.post({
    url: `${host.goapi}aggsearch/handler/SearchDoc`,
    data,
  })
}

// 获取城市
export function queryRegion(data) {
	return http.get({
    url: `${host.goapi}clinic/handler/QueryRegion`,
    data,
  })
}

export function queryVideoList(data) {
  return http.post({
    url: `${host.omoVideo}cmsApi/video/getList`,
    data,
  })
}

/**
 * 查询医生信息
 * @param {*} data 
 * @returns 
 */
export function queryDoctorDetail(data) {
  return http.get({
    url: `${host.goapi}doctor/handler/QueryDoctorDetail`,
    data,
  })
}


